import { GeoJsonProperties } from 'geojson';
import JSDCGeoJSONLayer from '../../Layer/JSDCGeoJSONLayer';
import { useRef } from 'react';
import Event from '../../utils/Event';
import L, { Marker } from 'leaflet';
import { fetchTrails, fetchQueryTrails } from './api';
import '../../../components/LeftMenuBar/Layer/LayerItem.scss';
import { TrailQueryApi } from '../../../apiConfigs/@types';
import { getListingCategoryStyle } from '../../utils/listingCategoryIcon';

export type UseTrailQueryOptions = {
  trailClickEvent: Event<GeoJsonProperties>;
  trailCreateEvent: Event<JSDCGeoJSONLayer>;
  trailRemoveEvent: Event<JSDCGeoJSONLayer>;
};

const useTrailQuery = ({
  trailClickEvent,
  trailCreateEvent,
  trailRemoveEvent,
}: UseTrailQueryOptions) => {
  const trailsLayer = useRef<JSDCGeoJSONLayer>(
    new JSDCGeoJSONLayer({
      id: 'trail',
      description: { name: 'trail', type: 'point' },
    }),
  ).current;

  const registerLayerClick = (jsdcLayer: JSDCGeoJSONLayer) => {
    jsdcLayer.forEachLayerAsGeoJSON<Marker, { [k: string]: any }>((layer, properties) => {
      const { icon, color } = getListingCategoryStyle(properties?.listing_category);
      layer.setIcon(
        L.divIcon({
          html: `<div class="cat-icon" style="background:${color}"><i class="las ${icon}"></i></div>`,
          className: 'cat-icon-wrap',
          iconSize: [32, 32],
          iconAnchor: [16, 16],
        }),
      );
      layer.on('click', async () => {
        trailClickEvent.raise(properties);
      });
    });
  };

  const clearTrails = () => {
    trailRemoveEvent.raise(trailsLayer);
    trailsLayer.instance?.getLayers().forEach((layer) => trailsLayer.instance?.removeLayer(layer));
  };

  const getAllTrails = async () => {
    const geojsonObject = await fetchTrails();
    trailsLayer.addFeature(geojsonObject);
    registerLayerClick(trailsLayer);
    trailCreateEvent.raise(trailsLayer);
    return trailsLayer;
  };

  const queryTrails = async (
    options: TrailQueryApi['Request'],
    reportStartDate: string,
    reportEndDate: string,
    occurence: string[],
  ) => {
    const geojsonObject = await fetchQueryTrails(
      options,
      reportStartDate,
      reportEndDate,
      occurence,
    );
    trailsLayer.addFeature(geojsonObject);
    registerLayerClick(trailsLayer);
    trailCreateEvent.raise(trailsLayer);
    return trailsLayer;
  };

  return {
    trailsLayer,
    getAllTrails,
    queryTrails,
    clearTrails,
  };
};

export default useTrailQuery;
